import { Box, Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { ReactFormGenerator } from 'react-form-builder2';
import { useParams } from 'react-router';
import { createLead, getLeadForm } from 'src/common/Scraper';
import './RenderLeadForm.css';
import CommonAlert from 'src/common/CommonAlert';
import { addSiteInDashboardText } from 'src/common/config/TextMessage';
import { posthogService, PostHogEvent } from 'src/common/services/posthogService';
const RenderLeadForm = () => {
  const [data, setData]: any = useState([]);
  const [loader, setLoader]: any = useState(null);
  const [loading, setLoading]: any = useState(null);
  const [alertData, setAlertData]: any = useState(null);
  const [submitButtonText, setSubmitButtonText] = useState('Submit');
  const [submitButtonColor, setSubmitButtonColor] = useState('#1976D2'); // Default color
  const [bgColor, setBgColor] = useState('var(--color-white)'); // Default color
  const [urlInputIds, setUrlInputIds] = useState(''); // Default color
  const [showAlert, setShowAlert] = useState(null);
  const [formKey, setFormKey] = useState(Date.now());
  const { id } = useParams();
  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const getLeadFormResponse: any = await getLeadForm(id); // Assuming getLeadForm is an async function
        if (getLeadFormResponse?.lead_form_details) {
          setData(getLeadFormResponse?.lead_form_details);
          setTimeout(() => {
            let requiredLabels: any = document.querySelectorAll(
              '.render-lead .label-required'
            );
            requiredLabels?.forEach((label) => {
              label.innerText = '*';
            });
          }, 100);
          setTimeout(() => {
            setLoading(false);
            window.parent.postMessage(
              {
                message: 'change_iframe_height',
                value: document.querySelector('.render-lead-box').scrollHeight
              },
              '*'
            );
          }, 1000);

          // This code is for sending the URL input element IDs to the state
          const leadFormResponse = getLeadFormResponse?.lead_form_details;
          // Filter elements with text === "URL Input" and extract their IDs
          const filteredIds = leadFormResponse
            ?.filter((item: any) => item?.text === 'URL Field')
            ?.map((item: any) => item?.id);
          // Update state with the filtered IDs
          setUrlInputIds(filteredIds?.[0]);
          setSubmitButtonColor(getLeadFormResponse?.button_color);
          setSubmitButtonText(getLeadFormResponse?.button);
          setBgColor(getLeadFormResponse?.bg_color);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching lead form data:', error);
      }
    })();
    return () => {};
  }, []);

  useEffect(() => {
    try {
      setTimeout(() => {
        let requiredLabels: any = document.querySelectorAll(
          '.render-lead .label-required'
        );
        requiredLabels.forEach((label) => {
          label.innerText = '*';
        });
      }, 100);
    } catch (error) {}
  }, []);

  useEffect(() => {
    try {
      if (showAlert == false) {
        setLoader(false);
        setTimeout(() => {
          setLoader(false);
          setShowAlert(true);
        }, 2000);
      }
    } catch (error) {}
  }, [showAlert]);

  const runLoader = () => {
    try {
      setFormKey(Date.now());
      setLoading(true);
      setTimeout(() => {
        let requiredLabels: any = document.querySelectorAll(
          '.render-lead .label-required'
        );
        requiredLabels?.forEach((label) => {
          label.innerText = '*';
        });
      }, 100);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const _onSubmit = async (submitData: any) => {
    try {
      setLoader(true);

      const safeUrlInputIds = urlInputIds ? urlInputIds : '';
      let isValidURL = false;

      if (safeUrlInputIds?.length > 0) {
        const matchedInputs = submitData?.filter((item) =>
          safeUrlInputIds?.includes(item.id)
        );
        const firstMatchedValue = matchedInputs?.[0]?.value ?? '';
        isValidURL =
          !!addSiteInDashboardText?.leadFormUrlRegex?.test(firstMatchedValue);
        setShowAlert(isValidURL);
      }

      if (!data) {
        setLoader(false);
        return;
      }

      const payload = {
        leadId: id,
        formDetails: submitData
      };
      if (isValidURL) {
        const createLeadFormResponse: any = await createLead(payload);
        if (createLeadFormResponse?.status === 'success' || createLeadFormResponse?.status === 200) {
          posthogService.track(PostHogEvent.LEAD_GEN_FORM_SUBMITTED, {
            lead_id: id
          });
        }
        setAlertData({
          status: createLeadFormResponse?.status ?? 'error',
          message: createLeadFormResponse?.message ?? 'Something went wrong.'
        });
      }

      setTimeout(() => {
        setLoader(false);
        setAlertData(null);
        setFormKey(Date.now());
        runLoader();
      }, 3000);
    } catch (error) {
      setAlertData({
        status: 'error',
        message: 'Unexpected error occurred. Please try again.'
      });
      setLoader(false);
    }
  };

  return (
    <Box>
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        >
          <CircularProgress size={45} sx={{}} />
        </div>
      )}
      <Box
        className="render-lead-box"
        sx={{
          width: '100%',
          backgroundColor: bgColor,
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
          display: loading ? 'none' : 'block'
        }}
      >
        {showAlert == false && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <CommonAlert
              severity={'error'}
              message={'Please enter the valid url in url field'}
            />
          </Box>
        )}
        {data && data?.length == 0 && <p>No form found</p>}
        {data && data?.length > 0 && (
          <Box className="modal-dialog">
            <Box className="render-lead modal-content">
              <ReactFormGenerator
                key={formKey}
                action_name="Save"
                form_action="/"
                form_method="POST"
                submitButton={
                  <Button
                    variant="contained"
                    type="submit"
                    style={{
                      marginRight: '1rem',
                      marginTop: '1rem',
                      backgroundColor: submitButtonColor
                    }}
                  >
                    {loader ? (
                      <CircularProgress sx={{ color: 'white' }} size={25} />
                    ) : (
                      submitButtonText
                    )}
                  </Button>
                }
                onSubmit={_onSubmit}
                data={data}
              />

              {alertData && (
                <Box sx={{ mt: 2 }}>
                  <CommonAlert
                    severity={alertData?.status}
                    message={alertData?.message}
                  />
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RenderLeadForm;
